import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { LocalStorage } from '../../../utils/localStorage';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import SingleFilter from '../component/SingleFilter';
import { HttpArcgis } from '../../../utils/http';
import { getInfoBulleMessage, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { loaderDataComponent } from '../../../utils/helper';
import { app_placeholder } from '../../../env.placeholders';

interface Props {
  parentCallback: Function;
  allBc: any;
  allInseeCodesContract: any;
  module: string;
}

const FiltersHydro = (props: Props) => {
  const infoBulleMessageDataSelectorHydro = getInfoBulleMessage(props.module); 
  const sessionCode = window.sessionStorage.getItem('contractCode')!;
  // options for mainActivity filter
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [optionsTypes, setOptionsTypes] = useState<any>([]);
  const [optionsNatures, setOptionsNatures] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  //la commune
  const [commune, setCommune] = useState(
    JSON.parse(window.sessionStorage.getItem('hydro_commune')!) || {
      name: '',
      code: '',
    }
  );
  //l'assimilé domestique
  const [type, setType] = useState(
    JSON.parse(window.sessionStorage.getItem('hydro_type')!) || {
      name: '',
      code: '',
    }
  );
  //l'assimilé domestique
  const [nature, setNature] = useState(
    JSON.parse(window.sessionStorage.getItem('hydro_nature')!) || {
      name: '',
      code: '',
    }
  );
  //l'année'
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('hydro_color')!) || ''
  );
  const [allInseeCodesContract] = useState<any>(props.allInseeCodesContract); 
  
  // feed main activity option unique values
  const prepareOptions = (data: any, setter: Function) => {
    let options: any[] = [];
    data.forEach((raw: any) => {
      options.push({ name: raw, code: raw });
    });
    setter(options);
  };

  const getOptions = async (
    pSessionCode: string,
    setter: Function,
    option: any,
    pFilters: object
  ) => {
    let query: string = defineDefinitionExpression(
      pFilters,
      'hydro',
      pSessionCode
    );
    let data: any[] = [];
    // form for request sevice (get section names)
    const formBody: string[] = [];
    formBody.push('where=' + query);
    formBody.push('outFields=' + option);
    formBody.push('returnDistinctValues=true');
    formBody.push('returnGeometry=false');
    formBody.push('orderByFields=' + option);
    formBody.push('f=json');
    formBody.push('user=' + LocalStorage.userMail.get());
    const formBodyToSend = formBody.join('&');

    try {
      const responseSections = await HttpArcgis.post(
        app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/303/query',
        JSON.stringify(formBodyToSend)
      );
      let datas: any[] = [];
      if (
        responseSections.status === 200 &&
        responseSections.data.features !== undefined
      ) {
        datas = responseSections.data.features;
        // get attibutes
        datas.forEach((feat) => {
          if (option === 'WorkTypeGroup') {
            data.push(feat['attributes'].WorkTypeGroup);
          } else {
            // for WorkTypeLabel field
            data.push(feat['attributes'].WorkTypeLabel);
          }
        });
      } else {
        console.log('Aucune données !');
      }
      prepareOptions(data, setter);
    } catch (error) {
      console.log('Failed to get data for dropdownlist !', error);
    }
  };

  // component did update
  useEffect(() => {
    const communesAndBC = allInseeCodesContract.concat(props.allBc);
    setCommuneOptions(communesAndBC);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // method to update options
  useEffect(() => {
    if (loading === false) {
      setLoading(true);
      getOptions(sessionCode, setOptionsTypes, 'WorkTypeGroup', {
        YearFromCurrentYear: fonctionnement,
        InseeCode: commune,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // avoid so many choices (more 100 natures possible) when no type filter is selected
    // to get nature choices, you need to selected a type filter
    if (type.code !== '') {
      setLoading(true);
      getOptions(sessionCode, setOptionsNatures, 'WorkTypeLabel', {
        YearFromCurrentYear: fonctionnement,
        InseeCode: commune,
        WorkTypeGroup: type,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps

   useEffect(() => {
    props.parentCallback({
      YearFromCurrentYear: fonctionnement,
      InseeCode: commune,
      WorkTypeGroup: type,
      WorkTypeLabel: nature,
    });
  }, [props.allInseeCodesContract]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={'hydro-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='fonctionnement'>
          <Word
            value='Fonctionnement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-fonctionnement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorHydro}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              fonctionnement !== '' &&
                props.parentCallback({
                  YearFromCurrentYear: d,
                  InseeCode: commune,
                  WorkTypeGroup: type,
                  WorkTypeLabel: nature,
                });
              window.sessionStorage.setItem('hydro_color', JSON.stringify(d));
            }}
            type='hydro'
            sessionStorageName='hydro_color'
          />
        </Container>
        {commune !== null && (
          <SingleFilter
            module='hydro'
            title='Commune / Bassin de Collecte :'
            filterName='commune'
            filterOptions={communeOptions}
            parentCallback={(d) => {
              setCommune(d);
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'hydro-filtre-type',
                setOptionsTypes
              );
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'hydro-filtre-nature',
                setOptionsNatures
              );
              props.parentCallback({
                YearFromCurrentYear: fonctionnement,
                InseeCode: d,
                WorkTypeGroup: {
                  name: '',
                  code: '',
                },
                WorkTypeLabel: {
                  name: '',
                  code: '',
                },
              });
            }}
          />
        )}
        {type !== null && (
          <SingleFilter
            module='hydro'
            title='Type :'
            filterName='type'
            filterOptions={optionsTypes}
            parentCallback={(d) => {
              setType(d);
              resetOptions(
                {
                  name: '',
                  code: '',
                },
                'hydro-filtre-nature',
                setOptionsNatures
              );
              props.parentCallback({
                YearFromCurrentYear: fonctionnement,
                InseeCode: commune,
                WorkTypeGroup: d,
                WorkTypeLabel: {
                  name: '',
                  code: '',
                },
              });
            }}
          />
        )}
        {nature !== null && (
          <SingleFilter
            module='hydro'
            title='Nature :'
            filterName='nature'
            filterOptions={optionsNatures}
            parentCallback={(d) => {
              setNature(d);
              if (d.code !== '') {
                props.parentCallback({
                  YearFromCurrentYear: fonctionnement,
                  InseeCode: commune,
                  WorkTypeGroup: type,
                  WorkTypeLabel: d,
                });
              }
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersHydro;
